// extracted by mini-css-extract-plugin
export var dropdownButton = "_2c-0";
export var fullWidthDropdownButton = "_2c-1";
export var icon = "_2c-3";
export var iconPlaceholder = "_2c-2";
export var menuItemRow = "_2c-9";
export var separator = "_2c-e";
export var shortcutContainer = "_2c-7";
export var shortcutContainerFilled = "_2c-8";
export var shortcutIconLg = "_2c-6";
export var shortcutIconMd = "_2c-5";
export var shortcutIconSm = "_2c-4";
export var submenuChevron = "_2c-d";
export var submenuDropdown = "_2c-a";
export var submenuTriggerRow = "_2c-b";
export var submenuTriggerRowOpen = "_2c-c";